/**
 *  KERJASAMA
 */

export default [
  /**
   *   Moment of Understanding (MoU)
   */
  {
    path: "/kerjasama/mou",
    name: "kerjasama-mou",
    component: () => import("../../views/rektorat/kerjasama/mou/Mou.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", active: true },
      ],
      pageTitle: "MoU",
    },
  },
  {
    path: "/kerjasama/mou/tambah",
    name: "kerjasama-mou-tambah",
    component: () => import("../../views/rektorat/kerjasama/mou/TambahMou.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Tambah MoU", active: true },
      ],
      pageTitle: "Tambah MoU",
    },
  },
  {
    path: "/kerjasama/mou/:mouId/edit",
    name: "kerjasama-mou-edit",
    component: () => import("../../views/rektorat/kerjasama/mou/EditMou.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Edit MoU", active: true },
      ],
      pageTitle: "Edit MoU",
    },
  },
  {
    path: "/kerjasama/mou/pihak-terkait/:mouId",
    name: "kerjasama-mou-pihak-terkait",
    component: () =>
      import("../../views/rektorat/kerjasama/mou/MouPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },

  {
    path: "/kerjasama/mou/:mouId/detail",
    name: "kerjasama-mou-detail",
    component: () => import("../../views/rektorat/kerjasama/mou/DetailMou.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Detail MoU", active: true },
      ],
      pageTitle: "Detail MoU",
    },
  },
  {
    path: "/kerjasama/mou/:mouId/dokumen",
    name: "kerjasama-mou-dokumen",
    component: () =>
      import("../../views/rektorat/kerjasama/mou/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/kerjasama/mou/:mouId/extended",
    name: "kerjasama-mou-extended",
    component: () =>
      import("../../views/rektorat/kerjasama/mou/PerpanjanganMou.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoU", url: "/kerjasama/mou" },
        { title: "Perpanjangan MoU", active: true },
      ],
      pageTitle: "Perpanjangan MoU",
    },
  },

  /**
   *  Moment of Agreement (MoA)
   */
  {
    path: "/kerjasama/moa",
    name: "kerjasama-moa",
    component: () => import("../../views/rektorat/kerjasama/moa/Moa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", active: true },
      ],
      pageTitle: "MoA",
    },
  },
  {
    path: "/kerjasama/moa/tambah",
    name: "kerjasama-moa-tambah",
    component: () => import("../../views/rektorat/kerjasama/moa/TambahMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Tambah MoA", active: true },
      ],
      pageTitle: "Tambah MoA",
    },
  },
  {
    path: "/kerjasama/moa/pihak-terkait/:moaId",
    name: "kerjasama-moa-pihak-terkait",
    component: () =>
      import("../../views/rektorat/kerjasama/moa/MoaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/kerjasama/moa/:moaId/dokumen",
    name: "kerjasama-moa-dokumen",
    component: () =>
      import("../../views/rektorat/kerjasama/moa/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/kerjasama/moa/:moaId/edit",
    name: "kerjasama-moa-edit",
    component: () => import("../../views/rektorat/kerjasama/moa/EditMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Edit MoA", active: true },
      ],
      pageTitle: "Edit MoA",
    },
  },

  {
    path: "/kerjasama/moa/:moaId/detail",
    name: "kerjasama-moa-detail",
    component: () => import("../../views/rektorat/kerjasama/moa/DetailMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Detail MoA", active: true },
      ],
      pageTitle: "Detail MoA",
    },
  },
  {
    path: "/kerjasama/moa/:moaId/extended",
    name: "kerjasama-moa-extended",
    component: () =>
      import("../../views/rektorat/kerjasama/moa/PerpanjanganMoa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "MoA", url: "/kerjasama/moa" },
        { title: "Perpanjangan MoA", active: true },
      ],
      pageTitle: "Perpanjangan MoA",
    },
  },

  /**
   *  Implementation Agreement (IA)
   */
  {
    path: "/kerjasama/ia",
    name: "kerjasama-ia",
    component: () => import("../../views/rektorat/kerjasama/ia/Ia.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", active: true },
      ],
      pageTitle: "IA",
    },
  },
  {
    path: "/kerjasama/ia/tambah",
    name: "kerjasama-ia-tambah",
    component: () => import("../../views/rektorat/kerjasama/ia/TambahIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Tambah IA", active: true },
      ],
      pageTitle: "Tambah IA",
    },
  },
  {
    path: "/kerjasama/ia/:iaId/edit",
    name: "kerjasama-ia-edit",
    component: () => import("../../views/rektorat/kerjasama/ia/EditIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Edit IA", active: true },
      ],
      pageTitle: "Edit IA",
    },
  },
  {
    path: "/kerjasama/ia/bentuk-kegiatan/:iaId",
    name: "kerjasama-ia-bentuk-kegiatan",
    component: () =>
      import("../../views/rektorat/kerjasama/ia/BentukKegiatan.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Bentuk Kegiatan", active: true },
      ],
      pageTitle: "Bentuk Kegiatan",
    },
  },
  {
    path: "/kerjasama/ia/pihak-terkait/:iaId",
    name: "kerjasama-ia-pihak-terkait",
    component: () =>
      import("../../views/rektorat/kerjasama/ia/IaPihakTerkait.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Pihak Terkait", active: true },
      ],
      pageTitle: "Pihak Terkait",
    },
  },
  {
    path: "/kerjasama/ia/:iaId/dokumen",
    name: "kerjasama-ia-dokumen",
    component: () =>
      import("../../views/rektorat/kerjasama/ia/TambahDokumenPendukung.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Dokumen Pendukung", active: true },
      ],
      pageTitle: "Dokumen Pendukung",
    },
  },
  {
    path: "/kerjasama/ia/:iaId/detail",
    name: "kerjasama-ia-detail",
    component: () => import("../../views/rektorat/kerjasama/ia/DetailIa.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "IA", url: "/kerjasama/ia" },
        { title: "Detail IA", active: true },
      ],
      pageTitle: "Detail IA",
    },
  },
  {
    path: "/kerjasama/reporting",
    name: "kerjasama-reporting",
    component: () =>
      import("../../views/rektorat/kerjasama/reporting/Reporting.vue"),
    meta: {
      breadcrumb: [
        { title: "Home", url: "/apps" },
        { title: "Kerjasama", url: "/submenu/kerjasama" },
        { title: "Reporting", active: true },
      ],
      pageTitle: "Reporting",
    },
  },

  {
    path: "/kerjasama/pedoman-penomoran-mou",
    beforeEnter() {
      location.href =
        "https://docs.google.com/spreadsheets/d/1apHMZmKkHu__D4nIU-kbk4Lr_t5KBAiO/edit?usp=sharing&ouid=110343869222867595069&rtpof=true&sd=true";
    },
  },
  {
    path: "/kerjasama/pedoman-penomoran-moa",
    beforeEnter() {
      location.href =
        "https://docs.google.com/spreadsheets/d/1A_4TETlx-qJTn9oP3P44_h2zc-9uV1OH/edit?usp=sharing&ouid=110343869222867595069&rtpof=true&sd=true";
    },
  },
  {
    path: "/kerjasama/pedoman-penomoran-ia",
    beforeEnter() {
      location.href =
        "https://docs.google.com/spreadsheets/d/1AhBO9k-rWa5ldPpalB3-_HhZWJmzHeYp/edit?usp=sharing&ouid=110343869222867595069&rtpof=true&sd=true";
    },
  },
  {
    path: "/kerjasama/reporting-ia-external",
    beforeEnter() {
      location.href =
        "https://api-gateway.ubpkarawang.ac.id/external/kerjasama/univ_ia";
    },
  },
];
